import { responseMapper } from '@mfe/search-service/src/engines/bloomreach-service/search-service/bloomreach-response-mapper';
import { sortForSizeGroups } from '../sort-for-size-groups';
import { removeColorSwatches } from '../remove-color-swatches';
import { MappedBloomreachResponse } from '../../../../../types/mapped-bloomreach-response';

const bloomreachResponseMapper = (
  data: Record<string, any>,
  enabledFeatures: Record<string, boolean>
): MappedBloomreachResponse => {
  const bloomreachResponseHasProducts = !data?.error && !!data?.response?.docs?.length;
  const configuration = { enabledFeatures };
  const responseMapperOptions = {
    alwaysShowPriceFacet: true,
    alwaysShowDepartmentFacet: true
  };

  const mappedBloomreachResponse = (bloomreachResponseHasProducts && globalThis.window)
    ? responseMapper(data, null, configuration, null, responseMapperOptions)
    : {};

  sortForSizeGroups(mappedBloomreachResponse);
  removeColorSwatches(mappedBloomreachResponse);

  return mappedBloomreachResponse;
};

export default bloomreachResponseMapper;
